<template lang="pug">
  .postList_container.page_container
    .page_header
      .page_header_column
        b-field.page_header_category
          b-select(
            v-model="searchForm.category"
            placeholder="カテゴリで絞り込む"
            rounded
            size="is-medium"
            @input="onFormChange")
            option(:value="null") 選択しない
            option(v-for="(category, index) in categoryList" :value="category.value") {{ category.screen_name }}
        b-field
          b-input(
            v-model="searchForm.key"
            placeholder="キーワードで検索"
            type="search"
            icon="search"
            rounded
            size="is-medium"
            @input="onFormChange")
      .page_header_column
        router-link(to="/post")
          b-button(
            type="is-info"
            size="is-medium"
            outlined
            icon-left="pen") 新規投稿
    .postList_List(v-if="articleList" v-cloak)
      b-table.postList_table(
        :data="articleList"
        :bordered="table.isBordered"
        :striped="table.isStriped"
        :narrowed="table.isNarrowed"
        :hoverable="table.isHoverable"
        :loading="table.isLoading"
        :focusable="table.isFocusable"
        :mobile-cards="table.hasMobileCards"
        :default-sort-direction="table.defaultSortDirection"
        :sort-icon="table.sortIcon"
        :sort-icon-size="table.sortIconSize"

        :paginated="table.isPaginated"
        :backend-pagination="table.backendPagination"
        :total="table.total"
        :per-page="table.limit"
        :current-page.sync="table.currentPage"
        @page-change="onPageChange"

        :backend-sorting="table.backendSorting"
        @sort="onSort"

        :pagination-simple="table.isPaginationSimple"
        :pagination-position="table.paginationPosition"
        @click="toPost")
        b-table-column(
          v-slot="props"
          field="release_flag"
          label="状態"
          width="8%"
          sortable)
          template
            b-tag._publish(
              v-if="props.row.release_flag"
              type="is-success"
              size="is-medium") 公開
            b-tag._publish(
              v-else
              size="is-medium") 下書き
        b-table-column(v-slot="props" field="title" label="タイトル" width="50%" sortable)
          span._title {{ props.row.title }}
        b-table-column(v-slot="props" field="category" label="カテゴリ" width="14%")
          span._category(v-if="props.row.category") {{ props.row.category.screen_name }}
        b-table-column(v-slot="props" field="published_at" label="公開日" width="12%" sortable)
          span._date {{ getYMD(props.row.published_at) }}
        b-table-column(v-slot="props" field="open_article" label="記事を見る" width="8%" centered)
          template(v-if="props.row.release_flag")
            button.ui-icon-button._external(v-if="props.row.link_flag" @click.stop="openLinkPage(props.row.link)")
              b-icon.is-opacity(icon="external-link-alt")
            button.ui-icon-button._eye(v-else @click.stop="openArticlePage(props.row.slug)")
              b-icon.is-opacity(icon="eye")
        b-table-column(v-slot="props" field="delete" label="" width="8%" centered)
          b-dropdown(
            aria-role="list"
            :position="optionDropdown.position"
            :can-close="optionDropdown.canClose"
            :close-on-click="optionDropdown.closeOnClick"
            :mobile-modal="optionDropdown.mobileModal"
            @click.native.stop)
            button.ui-icon-button(slot="trigger" type="button")
              b-icon.is-opacity(icon="ellipsis-v")
            b-dropdown-item(@click="duplicateArticleConfirm(props.row.id, props.row.title)" aria-role="listitem")
              .media
                b-icon.media-left.is-opacity(icon="copy")
                .media-content 複製する
            hr.dropdown-divider
            b-dropdown-item(@click="deleteArticleConfirm(props.row.id, props.row.title)" aria-role="listitem")
              .media
                b-icon.media-left.is-danger(icon="trash-alt")
                .media-content.has-text-danger 削除する
        template(v-slot:empty v-if="!isInitialLoading")
          p._empty_message 該当する記事はありません

</template>

<script>

export default {
  name: "Article",
  head: {
    title() {
      return {
        inner: '記事',
        separator: '|',
        complement: '管理画面',
      }
    }
  },
  data: function () {
    return {
      articleList: [],
      categoryList: [],
      isInitialLoading: true,

      /* b-table settings */
      table: {
        isEmpty: false,
        isBordered: false,
        isStriped: false,
        isNarrowed: false,
        isHoverable: true,
        isFocusable: false,
        isLoading: true,
        hasMobileCards: true,
        defaultSortDirection: "asc",
        sortIcon: "arrow-up",
        sortIconSize: "is-small",
        backendPagination: true,
        backendSorting: true,
        total: 0,
        isPaginated: true,
        isPaginationSimple: false,
        paginationPosition: "bottom",
        currentPage: 1,
        limit: 10,
        sort: 1,
        order: 'desc',
        field: 'published_at',
      },
      /* 絞り込みフォーム */
      searchForm: {
        category: null,
        key: "",
      },
      /* 3点リーダー */
      optionDropdown: {
        position: 'is-bottom-left',
        canClose: true,
        closeOnClick: true,
        mobileModal: false
      }
    }
  },
  created() {
    this.checkQuery()

    this.getCategoryList()
    this.getArticleList()
  },
  computed: {
    getYMD() {
      return function (dt) {
        if(dt){
          const dt_array = dt.split(" ")
          return dt_array[0]
        }
      }
    }
  },
  watch: {
    $route(to, from) {
      if( to || from ){
        this.checkQuery()

        this.getArticleList()

        setTimeout(
          function() {
            this.$nextTick(function(){
              window.scrollTo(0, 0)
            })
          }.bind(this),
          100
        );
      }
    }
  },
  methods: {
    setQuery() {
      let _query = {
        page: this.table.currentPage,
        sort: this.table.sort
      }
      if( this.searchForm.category !== null ) _query.content = this.searchForm.category
      if( this.searchForm.key !== '' ) _query.keyword = this.searchForm.key

      this.$router.push({ query: _query }, () => {}, () => {})
    },
    checkQuery() {
      if( this.$route.query.content ) this.searchForm.category = this.$route.query.content
      if( this.$route.query.keyword ) this.searchForm.key = this.$route.query.keyword
      if( this.$route.query.sort ) this.table.sort = Number(this.$route.query.sort)
      if( this.$route.query.page ) this.table.currentPage = Number(this.$route.query.page)
    },
    onFormChange() {
      this.table.currentPage = 1
      this.setQuery()
    },
    onPageChange(page) {
      this.table.currentPage = page

      this.setQuery()
    },
    onSort(field, order) {
      this.table.field = field
      this.table.order = order
      this.table.currentPage = 1

      if( this.table.field === 'published_at' ) {
        if( this.table.order === 'desc' ){
          this.table.sort = 1
        } else if( this.table.order === 'asc' ) {
          this.table.sort = 2
        }
      } else if( this.table.field === 'title' ) {
        if( this.table.order === 'asc' ){
          this.table.sort = 3
        } else if( this.table.order === 'desc' ) {
          this.table.sort = 4
        }
      } else if( this.table.field === 'release_flag' ) {
        if( this.table.order === 'asc' ){
          this.table.sort = 5
        } else if( this.table.order === 'desc' ) {
          this.table.sort = 6
        }
      }

      this.setQuery()
    },
    toPost(article) {
      this.$router.push({ name: "post", params: { id: article.id } });
    },
    openLinkPage(url) {
      window.open(url, '_blank')
    },
    openArticlePage(slug){
      window.open(process.env.VUE_APP_PUBLIC_HOST + '/' + slug, '_blank')
    },
    duplicateArticleConfirm(article_id, article_title){
      this.$buefy.dialog.confirm({
        title: article_title + ' を複製しますか？',
        message: '下書きの状態で記事が複製されます。',
        confirmText: '記事を複製する',
        cancelText: 'キャンセル',
        type: 'is-info',
        size: 'is-medium',
        hasIcon: false,
        onConfirm: () => {
          this.duplicateArticle(article_id)
        }
      })
    },
    deleteArticleConfirm(article_id, article_title){
      this.$buefy.dialog.confirm({
        title: article_title + ' を削除しますか？',
        message: '削除した記事は復元できません。<br>公開せずに保存しておく場合は、記事編集ページで下書きに設定して保存を押してください。',
        confirmText: '記事を削除する',
        cancelText: 'キャンセル',
        type: 'is-danger',
        size: 'is-medium',
        hasIcon: true,
        icon: 'exclamation-circle',
        onConfirm: () => {
          this.deleteArticle(article_id)
        }
      })
    },
    async getArticleList() {
      try {
        this.table.isLoading = true

        if( !Object.keys(this.$route.query).length ) {
          this.table.currentPage = 1
          this.table.sort = 1
        }

        const data_obj = {
          contents: this.searchForm.category,
          keyword: this.searchForm.key,
          limit: this.table.limit,
          offset: (this.table.currentPage - 1) * this.table.limit,
          sort: this.table.sort,
        }

        const res = await this.$axios.get(
          process.env.VUE_APP_API_ENDPOINT
          + process.env.VUE_APP_API_BASE_PATH
          + this.$constants.API_PATH.ARTICLES,
          { params: data_obj }
        )

        const r = res.data

        if (r.status == 1) {
          this.articleList = r.data

          this.table.total = r.meta.total_count
        } else {
          if(r.errors.length > 0 && r.errors[0].status == 403) {
            this.$store.dispatch('promptToLogin')
            return
          } else {
            this.$common.createErrorMessage(
              r.errors,
              '記事の取得に失敗しました。時間を空けて、もう一度お試しください。'
            )
          }
        }
      } catch (e) {
        this.$common.createErrorMessage(null, null)
      } finally {
        this.table.isLoading = false
        this.isInitialLoading = false
      }
    },
    async duplicateArticle(article_id) {
      try {
        const res = await this.$axios.put(
          process.env.VUE_APP_API_ENDPOINT
          + process.env.VUE_APP_API_BASE_PATH
          + this.$constants.API_PATH.ARTICLES_DUPLICATE.replace(':id', article_id),
        )

        const r = res.data

        if (r.status == 1) {
          this.$common.createSuccessMessage('記事を複製しました')

          this.table.currentPage = 1
          this.table.sort = 1

          this.setQuery()
        } else {
          if(r.errors.length > 0 && r.errors[0].status == 403) {
            this.$store.dispatch('promptToLogin')
            return
          } else {
            this.$common.createErrorMessage(r.errors, '記事の複製に失敗しました。時間を空けて、もう一度お試しください。')
          }
        }
      } catch (e) {
        this.$common.createErrorMessage(null, null)
      }
    },
    async deleteArticle(article_id) {
      try {
        const res = await this.$axios.delete(
          process.env.VUE_APP_API_ENDPOINT
          + process.env.VUE_APP_API_BASE_PATH
          + this.$constants.API_PATH.ARTICLES_.replace(':id', article_id)
        )

        const r = res.data

        if( r.status == 1 ){
          this.$common.createSuccessMessage('記事を削除しました')
          this.getArticleList()
        }else{
          if(r.errors.length > 0 && r.errors[0].status == 403) {
            this.$store.dispatch('promptToLogin')
            return
          } else {
            this.$common.createErrorMessage(r.errors, '記事の削除に失敗しました。時間を空けて、もう一度お試しください。')
          }
        }
      } catch (e) {
        this.$common.createErrorMessage(null, null)
      }
    },
    async getCategoryList() {
      const data_obj = {
        sort: 2,
      }
      try {
        const res = await this.$axios.get(
          process.env.VUE_APP_API_ENDPOINT
          + process.env.VUE_APP_API_BASE_PATH
          + this.$constants.API_PATH.CATEGORIES,
          { params: data_obj }
        )

        const r = res.data
        if (r.status == 1) {
          this.categoryList = r.data
        } else {
          if(r.errors.length > 0 && r.errors[0].status == 403) {
            this.$store.dispatch('promptToLogin')
            return
          } else {
            this.$common.createErrorMessage(r.errors, 'カテゴリの取得に失敗しました。時間を空けて、もう一度お試しください。')
          }
        }
      } catch (e) {
        this.$common.createErrorMessage(null, null)
      }
    },
  },
};
</script>